import React from 'react';
import { sendMessageToParent } from '../utils';

export const Cross = () => {
  const close = () => sendMessageToParent({ _: 'cancel' });
  return <div className="widget-cross" onClick={close} />;
};
